import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-aanbiedingen',
  templateUrl: '../../../../assets/html/fabrikanten_aanbiedingen.html',
  styleUrls: ['./aanbiedingen.component.css']
})
export class AanbiedingenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
